/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StateDto
 */
export interface StateDto {
    /**
     * State ID
     * @type {number}
     * @memberof StateDto
     */
    id: number;
    /**
     * State name
     * @type {string}
     * @memberof StateDto
     */
    name: string;
    /**
     * ISO2 state code
     * @type {string}
     * @memberof StateDto
     */
    iso2: string;
}

/**
 * Check if a given object implements the StateDto interface.
 */
export function instanceOfStateDto(value: object): value is StateDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('iso2' in value) || value['iso2'] === undefined) return false;
    return true;
}

export function StateDtoFromJSON(json: any): StateDto {
    return StateDtoFromJSONTyped(json, false);
}

export function StateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'iso2': json['iso2'],
    };
}

export function StateDtoToJSON(json: any): StateDto {
    return StateDtoToJSONTyped(json, false);
}

export function StateDtoToJSONTyped(value?: StateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'iso2': value['iso2'],
    };
}

